module.exports = __webpack_public_path__ + "static/media/sn.e071511b.svg";